import * as z from 'zod';
import { validaNomeCompleto } from '../../../../utils/ValidaNome';
import { validateCPF } from '../../../../utils/validations';

export const dependentsSchema = z.object({
  name: z.optional(
    z
      .string()
      .min(1, { message: 'Campo obrigatório' })
      .refine(val => validaNomeCompleto(val), {
        message: 'Digite o nome completo sem abreviações (ex: João da Silva)',
      }),
  ),
  birthDate: z
    .string()
    .min(1, { message: 'Campo obrigatório' })
    .regex(/^(\d{2})\/(\d{2})\/(\d{4})$/, {
      message: 'Formato inválido (use DD/MM/AAAA)',
    })
    .refine(
      value => {
        const [dia, mes, ano] = value.split('/').map(Number);
        const date = new Date(ano, mes - 1, dia);

        // Verifica se o Date é válido e se os valores batem
        return (
          date.getFullYear() === ano &&
          date.getMonth() === mes - 1 &&
          date.getDate() === dia
        );
      },
      { message: 'Data de nascimento inválida' },
    ),
  civilStatus: z.string().min(1, { message: 'Campo obrigatório' }),
  gender: z.string().min(1, { message: 'Campo obrigatório' }),
  parentage: z.string().min(1, { message: 'Campo obrigatório' }),
  cpf: z.optional(z.string()),
  cns: z.optional(z.string()),
  mothersName: z.optional(
    z
      .string()
      .min(1, { message: 'Campo obrigatório' })
      .refine(val => validaNomeCompleto(val), {
        message: 'Digite o nome completo sem abreviações (ex: João da Silva)',
      }),
  ),
});
